import { atom } from "recoil";

export const PlayButtonAtom = atom<{
  title: string;
  contextTag: string;
} | null>({
  key: "PlayButtonAtom",
  default: null,
});
